import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreatePurchasesQuoteRequestModel,
  DeletePurchasesQuoteRequestModel,
  SearchPurchasesQuoteRequestModel,
} from '../../../models/purchase-quote-request.model'

@Injectable({
  providedIn: 'root',
})
export class PurchasesQuoteRequestItinerariesService {
  private baseUrl = environment.baseUrl
  private resource: string = 'CompraSolicitacaoItinerario'

  constructor(private httpClient: HttpClient) {}

  public getPurchasesQuoteRequestItinerariesByRequestId(
    requestId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/OrigemDestino/list/${requestId}`,
    )
  }

  public updateRequestPurchase(
    proposalId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Atualizar/Itinerarios/${proposalId}`,
      {},
    )
  }
}
